<template>
  <GenericReport
    ref="report"
    class="maxh-2bar"
    hide-header
    :reportSpec="reportSpec"
    :adapterSpec="adapterSpec"
    :extraParams="{ vehicleIds: value.idInOrg }"
    @rowClicked="showRowDetails"
  >
    <template v-slot:sidebar-extra>
      <v-btn @click="() => $refs.report.checkDownload()">
        Exportar CSV
      </v-btn>
    </template>
  </GenericReport>
</template>

<script>
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import { fullSpec } from './trip-columns'

export default {
  tabTitle: 'Trechos',
  tabGroup: 'Veículo',
  components: {
    GenericReport
  },
  props: {
    value: { required: true }
  },
  data() {
    return { adapterSpec: fullSpec }
  },
  computed: {
    reportSpec() {
      let orgId = this.value.orgId
      let apiBase = `/organizations/${orgId}/api/v1/trips`
      return {
        code: 'trips',
        title: 'Trechos',
        apiBase,
        filters: ['DateRange'],
        orderByOptions: [
          { value: 'createdAt desc, id desc', text: 'createdAt desc, id desc' },
          { value: 'updatedAt desc, id desc', text: 'updatedAt desc, id desc' },
          {
            value: 'startTimestamp desc, id desc',
            text: 'startTimestamp desc, id desc'
          }
        ]
      }
    }
  }
}
</script>

<style></style>
